import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ModalCard from '../ui/ModalCard';
import StatusIconCircle from '../ui/StatusIconCircle';
import { XIcon } from '../icons';

export default function RegisterInvalidLinkCard() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ModalCard title={t('register.cardTitle')}>
      <StatusIconCircle icon={<XIcon size={24} />} variant="destructive" />

      <Typography variant="h3" component="h1">
        {t('register.complete.invalidLink.headline')}
      </Typography>

      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {t('register.complete.invalidLink.description')}
      </Typography>

      <Button
        type="button"
        variant="contained"
        fullWidth
        onClick={() => navigate('/register')}
        sx={(theme) => ({
          backgroundColor: theme.app.primary,
          color: theme.app.primaryForeground,
          '&:hover': { backgroundColor: theme.app.primaryHover },
        })}
      >
        {t('register.complete.invalidLink.backToStart')}
      </Button>
    </ModalCard>
  );
}
